import { render, staticRenderFns } from "./c-form.vue?vue&type=template&id=ab80cc38&scoped=true"
import script from "./c-form.vue?vue&type=script&lang=js"
export * from "./c-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab80cc38",
  null
  
)

export default component.exports